window.GrocerBox = {
  cartCollections: [],
  cartItemCollections: {},

  handleError(error) {
    if (typeof Honeybadger !== "undefined") {
      Honeybadger.notify(`Grocer Box Snippet Error: ${error}`);
    }
  },

  init(refundableItemOptions, timeSlotConfig, syncItemAttributes = false) {
    // console.log("initializing")
    // Syncing item attributes gives the backend access to the users choice of time slot and collections.
    // if (syncItemAttributes) {
    //   this.syncCartAttributes();
    // }

    let enableRefundableHold;

    if (timeSlotConfig.noRefundableHold) {
      enableRefundableHold = false;
    } else {
      enableRefundableHold = true;
    }

    if (refundableItemOptions) {
      this.setRefundableItem(refundableItemOptions, enableRefundableHold);
    } else {
      // We need to call getCart() in order for the cart.requestComplete event to fire and the line item property to get updated
      CartJS.getCart();
    }

    if (timeSlotConfig) {
      this.cartCollections = timeSlotConfig.cartCollections;
      this.cartItemCollections = timeSlotConfig.cartItemCollections;
    }

    const splitUrl = window.location.pathname.split("/");
    // console.log("waiting on page load")
    $(document).ready(() => {
      // console.log("loading page")
      if (
        (timeSlotConfig && splitUrl[splitUrl.length - 1] === "cart") ||
        timeSlotConfig.isSliderCart
      ) {
        try {
          setTimeout(() => {
            // console.log("one shot")
            window.GrocerBoxTimeSlotInit(timeSlotConfig);
          }, 750);
        } catch (err) {
          console.log("failed the first time");
          setTimeout(() => {
            window.GrocerBoxTimeSlotInit(timeSlotConfig);
          }, 750);
        }
      }
    });
  },

  addScript: (src, attributes, callback) => {
    var s = document.createElement("script");
    s.setAttribute("src", src);
    Object.keys(attributes).map((name) => {
      s.setAttribute(name, attributes[name]);
    });
    console.log({ s, body: document.body });
    s.onload = callback;
    document.body.appendChild(s);
  },

  syncCartAttributes() {
    $(document).on("cart.requestComplete", (event, cart) => {
      console.log("cart.requestComplete");
      console.log(
        cart.items.map((item) => item.properties).map((prop) => prop._gb)
      );
      if (cart.items.length === 0 || !cart.attributes.code) {
        return;
      }

      // TODO: Ensure we don't have multiple line items with the _gb property
      const decoded = JSON.stringify({
        code: cart.attributes.code,
        cartCollections: this.cartCollections,
        cartItemCollections: this.cartItemCollections,
      });
      console.log({ decoded: JSON.parse(decoded) });
      const encoded = btoa(decoded);
      const prop = { _gb: encoded };
      const gbItem = cart.items.filter((item) => item.properties._gb)[0];

      if (!gbItem) {
        const properties = {
          ...(cart.items[0].properties || {}),
          ...prop,
        };
        this.updateLineItemAttribute(1, cart.items[0].quantity, properties);
      } else if (gbItem.properties._gb !== encoded) {
        const lineNumber =
          cart.items.map((item) => item.id).indexOf(gbItem.id) + 1;

        const properties = {
          ...(gbItem.properties || {}),
          ...prop,
        };
        this.updateLineItemAttribute(lineNumber, gbItem.quantity, properties);
      }
    });
  },

  updateLineItemAttribute(lineNumber, quantity = undefined, properties) {
    CartJS.updateItem(lineNumber, quantity, properties, {
      success: function (data, textStatus, jqXHR) {
        console.log({ success: data });
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log({ error: errorThrown });
      },
    });
  },

  setRefundableItem(storeOptions, enableRefundableHold) {
    options = {
      refundableHoldHandle: null,
      largerRefundableHoldProducts: [],
      onlyForWeightedItems: true,
      largerRefundableHoldCartValueThreshold: false,
      ...storeOptions,
    };
    CartJS.getCart().then((cart) => {
      const cacheExpiry = 1000 * 60 * 60 * 24 * 14;
      const REFUNDABLE_HOLD_KEY = "refundableHoldItem";

      let needsRefundableHold = true;
      console.log(enableRefundableHold);

      if (!enableRefundableHold) {
        needsRefundableHold = false;
      }

      // const weightedItemOptions = ['10g', '15g', '30g', '35g', '45g', '65g', '80g', '90g', '100g', '150g', '1lb', 'lb', '1kg', 'kg'];

      if (options.onlyForWeightedItems) {
        const weightRegex = new RegExp(
          /[0-9]{0,3}(g|kg|oz|lb|G|KG|Kg|OZ|Oz|LB|Lb)/
        );
        const weightedItems = cart.items.filter((item) =>
          weightRegex.test(item.variant_title)
        );
        needsRefundableHold = weightedItems.length > 0;
      }

      // TODO: switch out refundable hold item for larger size if necessary
      // if (options.largerRefundableHoldProducts.length > 0 || options.largerRefundableHoldCartValueThreshold) {
      // }

      const refundableHoldInCart = cart.items.filter(
        (item) => item.handle === options.refundableHoldHandle
      )[0];
      const hasRefundableHoldInCart = !!refundableHoldInCart;

      // Check if ALL non-hold items are gift cards (skip/remove refundable hold for gift card-only orders)
      const nonHoldItems = cart.items.filter(
        (item) => item.handle !== options.refundableHoldHandle
      );
      const allItemsAreGiftCards =
        nonHoldItems.length > 0 &&
        nonHoldItems.every((item) => item.gift_card === true);

      if (allItemsAreGiftCards) {
        needsRefundableHold = false;
      }
      const needsLargerRefundableHold =
        cart.items.filter((item) => {
          let result = false;
          options.largerRefundableHoldProducts.forEach((title) => {
            if (item.title.indexOf(title) !== -1) {
              result = true;
            }
          });
          return result;
        }).length > 0;

      let refundableHoldItem = JSON.parse(
        localStorage.getItem(REFUNDABLE_HOLD_KEY)
      );

      if (
        refundableHoldItem &&
        new Date().getTime() - refundableHoldItem.time > cacheExpiry
      ) {
        localStorage.removeItem(REFUNDABLE_HOLD_KEY);
        refundableHoldItem = null;
      }

      // console.log({ needsRefundableHold, hasRefundableHoldInCart, refundableHoldInCart });

      if (needsRefundableHold && hasRefundableHoldInCart) {
        return;
      }

      if (!needsRefundableHold && hasRefundableHoldInCart) {
        localStorage.removeItem(REFUNDABLE_HOLD_KEY);

        CartJS.removeItemById(refundableHoldInCart.variant_id, {
          success: () =>
            window.location.pathname === "/cart"
              ? window.location.reload()
              : null,
          error: (error) =>
            handleError(`Error Removing Refundable Hold: ${error}`),
        });
      }

      if (needsRefundableHold && !hasRefundableHoldInCart) {
        if (refundableHoldItem) {
          this.addRefundableHold(
            cart,
            refundableHoldItem.data,
            needsLargerRefundableHold,
            options
          );
        } else {
          fetch(`/products/` + options.refundableHoldHandle + ".js")
            .then((res) => res.json())
            .then((data) => {
              localStorage.setItem(
                REFUNDABLE_HOLD_KEY,
                JSON.stringify({ data, time: new Date().getTime() })
              );

              if (!data || !data.variants || !data.variants.length) {
                handleError("Error adding Refundable Hold: no variant found");
                return;
              }
              this.addRefundableHold(
                cart,
                data,
                needsLargerRefundableHold,
                options
              );
            });
        }
      }
    });
  },

  addRefundableHold(cart, product, needsLargerRefundableHold, options) {
    const variants = product.variants.sort((a, b) => a.price - b.price);
    let variant_id = variants[0].id;

    // Use more expensive variant price for high value products or carts.
    if (
      needsLargerRefundableHold ||
      (options.largerRefundableHoldCartValueThreshold &&
        variants.length > 1 &&
        cart.total_price > options.largerRefundableHoldCartValueThreshold)
    ) {
      variant_id = variants[1].id;
    }

    // Get selected location from localStorage for delivery quote
    let lineItemProperties = {};
    try {
      const storedLocation = localStorage.getItem("selectedLocation");
      if (storedLocation) {
        const locationData = JSON.parse(storedLocation);
        if (locationData && locationData.name) {
          lineItemProperties._customerSelectedLocation = locationData.name;
        }
      }
    } catch (e) {
      console.error("Error reading selected location:", e);
    }

    CartJS.addItem(variant_id, 1, lineItemProperties, {
      success: () =>
        window.location.pathname === "/cart" ? window.location.reload() : null,
      error: (error) => handleError(`Error adding Refundable Hold: ${error}`),
    });
  },
};
